/* eslint-disable @typescript-eslint/promise-function-async */
import { Routes } from '@angular/router';
import { NavigationGuard } from '@core/guards/navigation.guard';
import { PackagesGuard } from '@core/guards/packages.guard';
import { Flow, RoutePaths } from '@global/routePaths';

export const PolicyDataRoutes: Routes = [
  {
    path: RoutePaths.NEW_QUOTATION.POLICY_DATA.VERTI_POLICY.route,
    loadChildren: () =>
      import('@pages/policy-data/verti-policy/verti-policy.module').then(m => m.VertiPolicyPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.POLICY_DATA.STARTING_DATE.route,
    loadChildren: () =>
      import('@pages/policy-data/starting-date/starting-date.module').then(m => m.StartingDatePageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.POLICY_DATA.PACKAGES.route,
    loadChildren: () => import('@pages/policy-data/packages/packages.module').then(m => m.PackagesPageModule),
    canActivate: [NavigationGuard, PackagesGuard],
    data: { parentPath: RoutePaths.NEW_QUOTATION.POLICY_DATA, flow: Flow.NEW_QUOTATION },
  },
  {
    path: RoutePaths.NEW_QUOTATION.POLICY_DATA.COVERAGES.route,
    loadChildren: () => import('@pages/policy-data/coverages/coverages.module').then(m => m.CoveragesPageModule),
    canActivate: [NavigationGuard],
  },
];
